import { CraProject } from "@ifa/utils";

const GENERIC_CRA_PROJECT_LABELS: Record<CraProject, string> = {
  [CraProject.CustomerRisk]: "客戶風險",
  [CraProject.DistributionOrDeliveryRisk]: "分期/支付風險",
  [CraProject.CountryOrRegionalRisk]: "國家或地區風險",
  [CraProject.ProductServiceRisk]: "產品/服務風險",
  [CraProject.FinalAmlCftRiskAssessment]: "最終AML/CTF風險評估",
};

const ZUU_CRA_PROJECT_LABELS: Record<string, string> = {
  VERIFICATION_OF_IDENTITY: "身分核實",
  COUNTRY_RISK: "國家風險",
  OCCUPATION_DETAILS: "職業資料",
  SOURCE_OF_FOUND_AND_WEALTH: "資金和財富來源",
  TRANSACTION: "交易活動",
  PRODUCT_RISK: "產品風險",
  IDENTIFICATION_PEP_AND_TERRORISTS: "識別政治人物及恐怖分子",
  FINAL_AML_CFT_RISK_ASSESSMENT: "最終AML/CTF風險評估",
};

export const CRA_PROJECT_LABELS: Record<string, string> = {
  ...GENERIC_CRA_PROJECT_LABELS,
  ...ZUU_CRA_PROJECT_LABELS,
};

export function resolveCraProjectLabel(project?: string | null): string {
  if (!project) return "未知項目";
  return CRA_PROJECT_LABELS[project] ?? project;
}
